import React from 'react'
import { toast } from 'react-toastify';
import { useForm } from "react-hook-form";
import useAxios from '../../hooks/useAxios';
import { useQuery } from 'react-query';
import Swal from 'sweetalert2';
import { Link, useParams } from 'react-router-dom';
import useBookperParthook from '../../hooks/useBookperParthook';
const Update = () => {
    const { register, handleSubmit,reset } =  useForm()
    const {id} =useParams()

const axiosPublic =useAxios()

    const onSubmit = data => {console.log(data)

        console.log(id)
       axiosPublic.patch(`/part/${id}`,data).then((res)=>{
      console.log(res.data)
      const data=res.data
      Swal.fire({
        title: `${data.message}`,
      
        icon: 'success',
        showConfirmButton:false,

        timer: 2500
    });
    
    reset()
    }).catch(err=>{
     

          
            Swal.fire({
              title: `${err.code}`,
            
              icon: 'error',
              showConfirmButton:false,
      
              timer: 2500
          });
          })
     
     

    };
    


    return (
<div className='py-[70px] '>
    <p className='text-center text-blue-400'><Link to='/dashboard/mangepart ' >Back</Link></p>
<h2 className='text-[30px] leading-[40px] text-center mb-5' >Add Quantity</h2>

<form className='max-w-[350px] mx-auto'   onSubmit={handleSubmit(onSubmit)}>



<div className="form-control w-full max-w-xs">
    <label className="label">
        <span className="label-text text-bold">Add Quantity</span>
    </label>
    <input
        {...register("availablequantity")} 
          
         
        type="number" placeholder="Available Quantity"
        className="input input-bordered w-full max-w-xs"

    />
 
</div>




   <div className='form-control w-full max-w-xs' > 
   <input className='btn btn-secondary w-full max-w-xs mt-5 ' type="submit" value='ADD' />

   </div>

</form>
</div>
  )
}

export default Update